import { Children, isValidElement, PropsWithChildren } from 'react';

/**
 * 判断是否显示 footer 区域。
 * - footer 为 null/undefined 时不显示。
 * - footer 为函数组件时始终显示（组件自行渲染内容，不依赖 props.children）。
 * - 其他元素若有 children 则用 children 是否为空判断。
 */
function hasVisibleFooter(footer: React.ReactNode | null | undefined): boolean {
  if (footer == null) return false;

  if (isValidElement(footer) && typeof footer.type === 'function') {
    // 函数组件可能不接收 children 却自行渲染内容（如 OrderReturnFooter），无法通过 props.children 判断，一律显示
    return true;
  }

  if (isValidElement(footer)) {
    const props = footer.props as { children?: React.ReactNode };
    const count = Children.count(props?.children);
    if (count === 0) return false;
  }
  return true;
}

export const OrderDrawerDetailBody = (
  props: PropsWithChildren<{
    footer?: React.ReactNode | null;
  }>,
) => {
  const { children, footer = null } = props;
  const showFooter = hasVisibleFooter(footer);

  return (
    <div className="overflow-hidden h-full flex flex-col">
      <div className="overflow-y-auto px-4 pb-4 flex-1">{children}</div>
      {showFooter ? (
        <div className="h-[56px] flex-shrink-0 flex justify-start  items-center px-4 bg-[var(--fett-bg-elevated)] shadow-tt">
          {footer}
        </div>
      ) : null}
    </div>
  );
};
